import {CONFIG, type Screen} from './config';

/**
 * Are we on one of the provided screens?
 */
export const isScreen = ( screens: Array<Screen> ): boolean => {
	return screens.includes( CONFIG.currentScreen );
};

/**
 * Object.keys() with type inference.
 *
 * Instead of getting `string[]` we get `keyof T[]`.
 */
export function keysOf<T extends object>( obj: T ): Array<keyof T> {
	return Object.keys( obj ) as Array<keyof T>;
}


/**
 * Object.entries() with type inference.
 *
 * Instead of getting `Array<[string, any]>` we get `Array<[keyof T, T[keyof T]]>`.
 */
export function entriesOf<T extends object>( obj: T ): Array<[ keyof T, T[keyof T] ]> {
	return Object.entries( obj ) as Array<[ keyof T, T[keyof T] ]>;
}
